// User roles constants
export const UserRoles = {
  ADMIN: 'ADMIN',
  SUPER_USER: 'SUPER_USER',
  USER: 'USER',
} as const;

// User interface role labels
export const UserRoleLabels = {
  [UserRoles.ADMIN]: 'IPC Admin',
  [UserRoles.SUPER_USER]: 'Super User',
  [UserRoles.USER]: 'User',
} as const;

// Account types constants
export const AccountTypes = {
  IPC_USER: 'IPC_USER',
  MAILBOX: 'MAILBOX',
} as const;

// UI representation of account types
export const AccountTypeLabels = {
  [AccountTypes.IPC_USER]: 'IPC User',
  [AccountTypes.MAILBOX]: 'Mailbox',
} as const;

// User status constants
export const UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
} as const;

// PPO constants
export const PPOValues = {
  ALL: 'All',
  IPC: 'IPC',
  ATA: 'ATA',
} as const;

// Module names and identifiers
export const ModuleNames = {
  ENO1_SAMPLING: 'eNO1 Sampling',
  E53_SAMPLING: 'e53 Sampling',
  SAMPLING_PLANNING: 'Sampling Planning',
  E55_WEIGHTS: 'e55 Weights',
  E09_IBRS: 'e09 IBRS',
  IPC_TD_ACCOUNTING: 'IPC TD Accounting',
  TD_ACCOUNTING: 'UPU TD Accounting',
} as const;

// Module URLs mapping
export const ModuleUrls = {
  [ModuleNames.ENO1_SAMPLING]: '/eno1',
  [ModuleNames.E53_SAMPLING]: '/e53',
  [ModuleNames.SAMPLING_PLANNING]: '/sampling-planning',
  [ModuleNames.E55_WEIGHTS]: '/e55',
  [ModuleNames.E09_IBRS]: '/e09',
  [ModuleNames.IPC_TD_ACCOUNTING]: '/ipc-td-accounting',
  [ModuleNames.TD_ACCOUNTING]: '/td-accounting',
} as const;

// Module color mappings for chips
export const ModuleChipColors = {
  'IPC ADMIN': { bg: '#FF4D4F', color: '#FFFFFF' },
  'SUPERUSER': { bg: '#00BCD4', color: '#FFFFFF' },
  'ENO1 SAMPLING': { bg: '#2196F3', color: '#FFFFFF' },
  'E53 SAMPLING': { bg: '#333333', color: '#FFFFFF' },
  'SAMPLING PLANNING': { bg: '#607D8B', color: '#FFFFFF' },
  'E55 WEIGHTS': { bg: '#4CAF50', color: '#FFFFFF' },
  'E09 IBRS': { bg: '#9C27B0', color: '#FFFFFF' },
  'IPC TD ACCOUNTING': { bg: '#FF9800', color: '#FFFFFF' },
  'UPU TD ACCOUNTING': { bg: '#795548', color: '#FFFFFF' },
  'DEFAULT': { bg: '#E0E0E0', color: '#000000' },
} as const;

// Module keys mapping used for toggling
export const ModuleToggleKeys = {
  'ENO1': ModuleNames.ENO1_SAMPLING,
  'E53': ModuleNames.E53_SAMPLING,
  'SAMPLING': ModuleNames.SAMPLING_PLANNING,
  'E55': ModuleNames.E55_WEIGHTS,
  'E09': ModuleNames.E09_IBRS,
  'IPC_ACC': ModuleNames.IPC_TD_ACCOUNTING,
  'TD_ACC': ModuleNames.TD_ACCOUNTING,
} as const;

// Default module data structure (for when adding a new user)
export interface ModulePermission {
  id?: number;
  name: string;
  url: string;
  enabled: boolean;
}

export interface ModuleData {
  id?: number;
  name: string;
  url: string;
  enabled: boolean;
  permissions: ModulePermission[];
}

// Export all constants in a grouped manner for easier imports
export const UserConstants = {
  Roles: UserRoles,
  RoleLabels: UserRoleLabels,
  AccountTypes: AccountTypes,
  AccountTypeLabels: AccountTypeLabels,
  Status: UserStatus,
  PPOValues: PPOValues,
  ModuleNames: ModuleNames,
  ModuleUrls: ModuleUrls,
  ModuleChipColors: ModuleChipColors,
  ModuleToggleKeys: ModuleToggleKeys,
  // References to ids will be loaded from moduleIds.ts
  ModuleIds: 'ModuleIds' as const,
  PermissionIds: 'PermissionIds' as const,
};

export default UserConstants; 